(function(){
  function canNativeHls(video){
    return video.canPlayType && (video.canPlayType('application/vnd.apple.mpegurl') || video.canPlayType('application/x-mpegURL'));
  }
  function loadScript(src){
    return new Promise(function(resolve, reject){
      var s = document.createElement('script');
      s.src = src;
      s.async = true;
      s.onload = function(){ resolve(); };
      s.onerror = function(){ reject(new Error('Failed to load ' + src)); };
      document.head.appendChild(s);
    });
  }
  function initVideo(video){
    var hlsUrl = video.getAttribute('data-hls-src');
    if(!hlsUrl) return;

    // If Safari or any browser with native HLS support
    if(canNativeHls(video)){
      // If there are no <source> elements for HLS, set src directly
      var hasHlsSource = false;
      for (var i=0;i<video.children.length;i++){
        if(video.children[i].tagName === 'SOURCE' && (video.children[i].type === 'application/vnd.apple.mpegurl' || video.children[i].type === 'application/x-mpegURL')){
          hasHlsSource = true; break;
        }
      }
      if(!hasHlsSource){
        var source = document.createElement('source');
        source.src = hlsUrl;
        source.type = 'application/vnd.apple.mpegurl';
        video.appendChild(source);
      }
      // On some browsers it's enough to set src directly
      if(!video.src) video.src = hlsUrl;
      return;
    }

    // If hls.js is present, use it; otherwise, load it and then use it
    function attachHls(){
      if(window.Hls && window.Hls.isSupported()){
        try{
          var hls = new window.Hls({
            autoStartLoad: true,
            startPosition: -1,
          });
          hls.loadSource(hlsUrl);
          hls.attachMedia(video);
        }catch(e){
          console.error('HLS init error', e);
        }
      }
    }

    if(!window.Hls){
      loadScript('https://cdn.jsdelivr.net/npm/hls.js@1.5.6/dist/hls.min.js').then(attachHls).catch(function(err){
        console.warn('Unable to load hls.js', err);
      });
    } else {
      attachHls();
    }
  }

  function initAll(){
    var videos = document.querySelectorAll('video[data-hls-src]');
    for(var i=0;i<videos.length;i++) initVideo(videos[i]);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
